import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { AgreementPlansListFilters } from "@modules/agreementPlans/components";

import { useAgreementsPlansList } from "./controller";
import { useAgreementPlansListColumns } from "./columns";

export const AgreementPlansList = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    agreement,
    selectedRows,
    dataToExport,
    setSelectedRows,
    refetch,
    translate,
  } = useAgreementsPlansList();

  const columns = useAgreementPlansListColumns(refetch, translate, agreement);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
              for_agreement: "",
            }}
          >
            <AgreementPlansListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="agreements.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />
    </List>
  );
});
